function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import EmptyList from './EmptyList';
import StackButton from './StackButton';
import Title from './Title';
import useInfiniteLoading from './useInfiniteLoading';
import ListWrapper from '../../../common/components/ListWrapper';
import Divider from '../decoratives/Divider';
import InfiniteLoader from '../decoratives/InfiniteLoader';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
const ExplorerList = _ref => {
  let {
    children,
    records = [],
    groupTitle,
    entityTitle,
    previousLevel = '',
    previousLevelClick: handleBackDefault = () => {},
    navigatorBar,
    infLoading,
    loadMore,
    hasMore,
    observerOptions,
    emptyListCallback,
    ...restProps
  } = _ref;
  const entities = [];
  let groupRecordslen = 0;
  let showDivider = false;
  const {
    backButton: {
      onClick = () => {},
      ...restBackButtonProps
    } = {}
  } = navigatorBar;
  const root = document.querySelector('[data-naos-component="disclosure"]');
  const {
    measureRef
  } = useInfiniteLoading(hasMore, loadMore, infLoading, {
    ...observerOptions,
    root: observerOptions.root ?? root
  });
  if (records.length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      "data-naos-component": "explorer",
      className: treeStyles['sib-tree-view--exp']
    }, previousLevel ? /*#__PURE__*/React.createElement(StackButton, _extends({}, restBackButtonProps, {
      label: previousLevel,
      onClick: e => {
        handleBackDefault(e);
        onClick(e);
      }
    })) : null, /*#__PURE__*/React.createElement(EmptyList, {
      emptyListCallback: emptyListCallback
    }));
  }
  const getChild = (treeNode, i, items) => loadMore ? children(i, {
    treeNode,
    measureRef: i === items.length - 1 ? measureRef : null,
    ...restProps
  }) : children(i, {
    treeNode,
    ...restProps
  });
  const groupRecords = /*#__PURE__*/React.createElement(React.Fragment, null, groupTitle && /*#__PURE__*/React.createElement(Title, {
    title: groupTitle
  }), /*#__PURE__*/React.createElement(ListWrapper, {
    className: `${treeStyles['sib-tree-view__exp-list']}`
  }, records.map(function () {
    let treeNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let i = arguments.length > 1 ? arguments[1] : undefined;
    const isGroup = Array.isArray(treeNode?.children);
    if (isGroup) {
      groupRecordslen += 1;
      return getChild(treeNode, i, records);
    }
    entities.push(treeNode);
  })));
  showDivider = groupRecordslen > 0 && entities.length > 0 ? true : false;
  return /*#__PURE__*/React.createElement("div", {
    "data-naos-component": "explorer",
    className: treeStyles['sib-tree-view--exp']
  }, previousLevel ? /*#__PURE__*/React.createElement(StackButton, _extends({}, restBackButtonProps, {
    label: previousLevel,
    onClick: e => {
      handleBackDefault(e);
      onClick(e);
    }
  })) : null, entities.length === records.length ? null : groupRecords, entities.length ? /*#__PURE__*/React.createElement(React.Fragment, null, showDivider && /*#__PURE__*/React.createElement(Divider, null), entityTitle && /*#__PURE__*/React.createElement(Title, {
    title: entityTitle
  }), /*#__PURE__*/React.createElement(ListWrapper, {
    className: `${treeStyles['sib-tree-view__exp-list']}`
  }, entities.map(function () {
    let treeNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let i = arguments.length > 1 ? arguments[1] : undefined;
    return getChild(treeNode, i, entities);
  }))) : null, /*#__PURE__*/React.createElement(InfiniteLoader, {
    hasMore: hasMore,
    loading: infLoading
  }));
};
ExplorerList.propTypes = {
  children: PropTypes.func,
  records: PropTypes.array,
  expandedRecords: PropTypes.array,
  selectedRecords: PropTypes.array,
  groupTitle: PropTypes.string,
  entityTitle: PropTypes.string,
  previousLevel: PropTypes.string,
  previousLevelClick: PropTypes.func,
  navigatorBar: PropTypes.object,
  infLoading: PropTypes.bool,
  loadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  observerOptions: PropTypes.object,
  emptyListCallback: PropTypes.func
};
export default /*#__PURE__*/React.memo(ExplorerList);